<template>
  <div class="box gray-box">
    <div class="box-body inner-title">
      <el-row class="box-header">
        <el-col :span="18">
          <h3 v-if="support_transport_service == '1'">代下单收货地址</h3>
          <h3 v-if="support_transport_service == '2'">代买收货地址</h3>
        </el-col>
        <el-col :span="6">
          <span style="float:right;" @click="goAddress()"><a style="cursor: pointer;">更改</a></span>
        </el-col>
      </el-row>
      <div class="content">
        <SingleAddress :address="data" :support_transport_service="support_transport_service"></SingleAddress>
      </div>
    </div>
  </div>
</template>

<script>
import SingleAddress from '../address/SingleAddress'

export default {
  name: 'OrderTotal',
  props: ['data', 'support_transport_service'],
  components: {
    SingleAddress: SingleAddress
  },
  data () {
    return {
    }
  },
  methods: {
    goAddress () {
      this.$router.push({ path: 'address', query: this.$route.query })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.total-line {
  color: #686B73;
  line-height: 22px;

  .name {
    font-size: 16px;
    margin-bottom: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/components/AddressDetail.vue